// import './App.css';
import { Main } from './Components/Layout/Main';
import { Scrollwrapper } from './Components/Scrollwrapper';
import { Routers } from './Router';
import { Globalstyle } from './Styles/GlobalStyles';

function App() {
  return (
    <Globalstyle>
    <div className="App">
   <Routers/>
   <Scrollwrapper/>
    </div>
    </Globalstyle>
  );
}

export default App;
